import { useTranslation } from 'react-i18next';
import { useSession } from '../../app/session.js';
import { PageHeader } from '../../components/common.js';
import type { AppsSearch } from '../assets/logic.js';
import { AppsList, SyncButton } from './apps.js';

/**
 * Lista de apps, só com os que a pessoa abre no Qlik (o corte é do servidor). Os clientes saíram da tela para a
 * apresentação à SEFAZ (29/10/2026): o cadastro continua no banco e a tela de um cliente ainda abre pelo endereço.
 */
export function ClientsPage({ search, setSearch }: { search: AppsSearch; setSearch: (patch: Partial<AppsSearch>, replace?: boolean) => void }) {
  const { t } = useTranslation();
  const isAdmin = Boolean(useSession().data?.is_admin);
  return (
    <>
      <PageHeader title={t('clients.myApps')} subtitle={isAdmin ? t('clients.subtitle') : t('clients.myAppsHelp')} actions={isAdmin ? <SyncButton /> : undefined} />
      <AppsList search={search} setSearch={setSearch} />
    </>
  );
}
